import { render, staticRenderFns } from "./small-header.vue?vue&type=template&id=ee7f066c"
import script from "./small-header.vue?vue&type=script&lang=js"
export * from "./small-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports